import { createAppAsyncThunk } from '../../../../common/thunk';
import { OnboardingRequest } from '../../onboardingRequest';
import OnboardingServices from '../../../../services/onboarding.services';
import { ServicesSectorState, ServicesSectorTestimonialsRate } from './servicesSlice';
import { IBenefits, IExperience, IRates } from '../../../../common/interfaces/ServicesInterfaces';
import IPicture from '../../../../common/interfaces/IPicture';

export interface ServicesPatchRequestData {
  sector: string;
  isPrimary: boolean;
  specialties: string[];
  customSpecialties: string[];
  experience: IExperience;
  helps: IBenefits[];
  customHelps: string[];
  targetAudience: string[];
  appointmentTypes: string[];
  customAppointmentTypes: string[];
  rates: IRates[];
  ratesDescription?: string;
  picture?: IPicture;
}

const prepareExperience = (sector: ServicesSectorState): IExperience => {
  return {
    year: !sector.testimonials?.year ? '' : sector.testimonials?.year,
    explanatory: sector.testimonials?.explanatory || '',
    hideOnSite: sector.testimonials?.yearChecked || false,
  };
};

const prepareRate = (rate: ServicesSectorTestimonialsRate): IRates => {
  return {
    description: rate.description || '',
    price: rate.price || '',
    currency: rate.currency,
    active: rate.isActive,
  };
};

export const prepareService = (service: ServicesSectorState): ServicesPatchRequestData => {
  return {
    sector: service.sector.id || service.sector.title,
    isPrimary: service.primary || false,
    specialties: service.testimonials?.specialities?.filter(it => !it.isCustom).map(it => it.id) || [],
    customSpecialties: service.testimonials?.specialities?.filter(it => it.isCustom).map(it => it.name) || [],
    experience: prepareExperience(service),
    helps: service.testimonials?.benefits?.filter(it => !it.isCustom).map(it => ({ title: it.title, translated: it.translated })) || [],
    customHelps: service.testimonials?.benefits?.filter(it => it.isCustom).map(it => it.name) || [],
    targetAudience: service.testimonials?.audiences?.map(it => it.name) || [],
    appointmentTypes: service.testimonials?.appointments?.filter(it => !it.isCustom).map(it => it.id) || [],
    customAppointmentTypes: service.testimonials?.appointments?.filter(it => it.isCustom).map(it => it.name) || [],
    rates: service.testimonials?.rates?.filter(it => !!it.description || !!it.price || !!it.currency).map(it => prepareRate(it)) || [],
    ratesDescription: service.testimonials?.ratesAdditional,
    picture: service.testimonials?.illustration?.id
      ? { id: service.testimonials?.illustration?.id || '', url: service.testimonials?.illustration?.url || '' }
      : undefined,
  };
};

export const confirmServicesStep = createAppAsyncThunk('onboarding/confirmServices', (requestData: OnboardingRequest) => {
  const id = requestData.id;
  if (!requestData.services) {
    throw Error('Missed Services data');
  }
  return OnboardingServices.confirmOnboardingServices(id, requestData.services).then(response => response.data);
});
